module.exports = __webpack_public_path__ + "static/media/accident-default-image5.1f037536.png";